module.exports = __webpack_public_path__ + "7bc5fc40b2227a9ea962bc7c30d7f5b2.jpg";